/**
 * EVM 注入钱包 accountsChanged / chainChanged 回调注册。
 * store 注入实现，inject.mjs 调用，避免 location.reload 循环刷新。
 */

let hooks = null

export function setEvmInjectEventHooks(next) {
  hooks = next || null
}

export function getEvmInjectEventHooks() {
  return hooks
}

export function dispatchEvmAccountsChanged(accounts) {
  if (hooks?.onAccountsChanged) {
    hooks.onAccountsChanged(accounts)
    return true
  }
  return false
}

export function dispatchEvmChainChanged(chainHex) {
  if (hooks?.onChainChanged) {
    hooks.onChainChanged(chainHex)
    return true
  }
  return false
}
